import React from 'react';
import { motion } from 'framer-motion';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
}
export function PageHeader({
  title,
  subtitle
}: PageHeaderProps) {
  return <section className="relative bg-gesl-dark pt-32 pb-20 overflow-hidden" data-id="element-213">
      {/* Decorative Pattern */}
      <div className="absolute inset-0 bg-hero-pattern opacity-10" data-id="element-214" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gesl-dark/50 to-gesl-dark" data-id="element-215" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-217">
          <div className="flex items-center gap-3 mb-4" data-id="element-218">
            <div className="h-px w-12 bg-gesl-gold" data-id="element-219" />
            <span className="text-gesl-gold font-semibold tracking-wider uppercase text-sm" data-id="element-220">
              Greenwater Environmental Services
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4" data-id="element-221">
            {title}
          </h1>
          {subtitle && <p className="text-lg md:text-xl text-white/70 max-w-2xl" data-id="element-222">
              {subtitle}
            </p>}
        </motion.div>
      </div>
    </section>;
}